import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/diveAN/step2';
import { TypeVoie } from '../models/TypeVoie';
@Component({
  selector: 'app-type-voie',
  templateUrl: './type-voie.component.html'
})
export class TypeVoieComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeVoie'
  @Input() parentForm: FormGroup;
  @Input() voie : TypeVoie;

  public step2 = new Step2();

  constructor() { }

  public ngOnInit() {
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
}